import { useTranslation } from "react-i18next"
import { UserCog } from "lucide-react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { useUserPermissions } from "@/hooks/useUserPermissions"

const UserManagementSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { hasPermission, loading } = useUserPermissions()

  if (
    loading ||
    (!hasPermission("users.create") && !hasPermission("users.update"))
  ) {
    return null
  }

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.USER_MANAGEMENT}
      icon={UserCog}
      activeIcon={UserCog}
      tooltipText={t("app.sidebar.userManagement")}
      className={className}
    />
  )
}

export default UserManagementSidebarButton
